import { ComponentKind, MutatingScreenKind } from "../description";
import { SimpleComponentDescription, SimpleComponentHandler } from "./simple-handler";
import { VideoUI } from "../../components/uis";
import { makeTextPropertyDescriptor } from "./descriptor-utils";

const ComponentKindVideo: ComponentKind = "video";

export class VideoComponentHandler extends SimpleComponentHandler {
    constructor() {
        super({
            kind: ComponentKindVideo,
            name: "Video",
            group: "Media",
            description: "Embed video from YouTube, Vimeo, etc.",
            img: "componentVideo",
            uiClass: VideoUI,
            helpPath: "videoPlayer",
        });
    }

    protected getPropertyDescriptors(
        _desc: SimpleComponentDescription,
        mutatingScreenKind: MutatingScreenKind | undefined
    ) {
        return [
            {
                descriptor: () =>
                    makeTextPropertyDescriptor("urlProperty", "Video", "Enter URL", true, mutatingScreenKind, {
                        preferredType: "uri",
                        preferredNames: ["video"],
                        searchable: false,
                        columnFirst: true,
                    }),
                argumentName: "url",
            },
        ];
    }
}
